/**
 * JWT da sessão do usuário: memória + sessionStorage (sobrevive ao F5 na mesma aba).
 * Fonte de escrita: campo `jwt` em GET /api/usuario, POST /api/login e respostas equivalentes.
 */
const JWT_SESSION_STORAGE_KEY = 'isend.jwt_token';

let memoryJwt = null;

function isLikelyJwt(value) {
  const parts = String(value).trim().split('.');
  return parts.length === 3 && parts.every((part) => part.length > 0);
}

function normalizeBearerToken(raw) {
  if (typeof raw !== 'string') return null;
  let token = raw.trim();
  if (!token) return null;
  if (token.toLowerCase().startsWith('bearer ')) {
    token = token.slice(7).trim();
  }
  return isLikelyJwt(token) ? token : null;
}

/** Lê o JWT da sessão local (memória → sessionStorage). */
export function readJwtFromLocalSession() {
  if (memoryJwt) return memoryJwt;
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(JWT_SESSION_STORAGE_KEY);
    if (!raw) return null;
    const trimmed = raw.trim();
    if (!isLikelyJwt(trimmed)) {
      sessionStorage.removeItem(JWT_SESSION_STORAGE_KEY);
      return null;
    }
    memoryJwt = trimmed;
    return trimmed;
  } catch (error) {
    return null;
  }
}

/** Persiste ou remove o JWT da sessão local. */
export function writeJwtToLocalSession(token) {
  if (token == null || String(token).trim() === '') {
    memoryJwt = null;
    if (typeof sessionStorage !== 'undefined') {
      try {
        sessionStorage.removeItem(JWT_SESSION_STORAGE_KEY);
      } catch (error) {
        /* quota, modo privado, etc. */
      }
    }
    return;
  }

  const trimmed = String(token).trim();
  if (!isLikelyJwt(trimmed)) {
    writeJwtToLocalSession(null);
    return;
  }

  memoryJwt = trimmed;
  if (typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.setItem(JWT_SESSION_STORAGE_KEY, trimmed);
    } catch (error) {
      /* quota, modo privado, etc. */
    }
  }
}

export function clearJwtLocalSession() {
  writeJwtToLocalSession(null);
}

/** Persiste o JWT retornado no JSON da API (`jwt` em /api/usuario, /api/login, etc.). */
export function persistJwtFromApiResponse(data) {
  if (!data || typeof data !== 'object') return;
  const token = normalizeBearerToken(data.jwt);
  if (token) writeJwtToLocalSession(token);
}
